import { render, staticRenderFns } from "./PublishingCompanyIndex.vue?vue&type=template&id=3566b00d"
import script from "./PublishingCompanyIndex.vue?vue&type=script&lang=js"
export * from "./PublishingCompanyIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports